import React from 'react';
import { Alert, Button, Modal } from 'antd';
import { mergeBannerOf, mergeBoxOf, type MergePlan } from './workflowFourMergePropsUtils';

// 261030 S5c — băng «Gộp đạo cụ trùng (N)» (bước ① và tab Đạo cụ ②) + hộp xác nhận chữ. Không tiền.
export const FourMergePropsBanner: React.FC<{ plan: MergePlan; busy: boolean; showButton?: boolean; onOpen: () => void }> = ({ plan, busy, showButton = true, onOpen }) => {
  const b = mergeBannerOf(plan);
  return <Alert className="wf4-banner" data-testid="merge-props-banner" type="info" showIcon message={b.title} description={b.description}
    action={showButton ? <Button size="small" type="primary" disabled={busy} onClick={onOpen} data-testid="merge-props-btn">{b.label}</Button> : undefined} />;
};

/** `plan` = đúng kế hoạch người đang xem (băm `plan.hash` được gửi làm `planHash`). */
export const FourMergePropsModal: React.FC<{ plan: MergePlan | null; gate1Ok: boolean; busy: boolean; onCancel: () => void; onOk: () => void }> = ({ plan, gate1Ok, busy, onCancel, onOk }) => {
  const box = plan ? mergeBoxOf(plan, gate1Ok) : null;
  return <Modal open={!!plan} title={box?.title} okText={box?.okText} cancelText="Huỷ" confirmLoading={busy} onCancel={() => { if (!busy) onCancel(); }} onOk={onOk} destroyOnClose>
    {box && <div data-testid="merge-props-box">
      <ul data-testid="merge-props-list" style={{ margin: '0 0 8px', paddingLeft: 18 }}>{box.lines.map((l) => <li key={l}>{l}</li>)}</ul>
      {box.notes.map((n) => <p key={n} className="muted" style={{ margin: '4px 0' }}>{n}</p>)}
    </div>}
  </Modal>;
};
